/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Tooltip } from '@waca/ca-ui-toolkit';
import stringResource from 'ba-common-nls';

import './ColorRangedNumber.scss';

export default class ColorRangedNumber extends Component<any, any> {
	static propTypes = {
		value: PropTypes.number.isRequired,
		ranges: PropTypes.array,
		decimal: PropTypes.number,
		className: PropTypes.string,
		predicate: PropTypes.func,
	};

	static defaultProps = {
		decimal: 0,
		predicate: (value, [from, to]) => value > from && value <= to,
		ranges: [
			{
				range: [0.8, 1],
				color: 'c1',
				tooltip: stringResource.get('confidenceLevelHigh'),
			},
			{
				range: [0.5, 0.8],
				color: 'c2',
				tooltip: stringResource.get('confidenceLevelMedium'),
			},
			{
				range: [0, 0.5],
				color: 'c3',
				tooltip: stringResource.get('confidenceLevelLow'),
			},
		],
	};

	render() {
		const { value, ranges, decimal, predicate, className } = this.props;
		const range = ranges.find(r => predicate(value, r.range)) || {
			color: '',
			tooltip: stringResource.get('confidenceLevelOutOfBoundary'),
		};

		return (
			<Tooltip className={`${className} bi-common-color-ranged-number`} title={range.tooltip}>
				<div className={`bi-common-color-ranged-number__${range.color}`}>
					{`${(value * 100).toFixed(decimal)}%`}
				</div>
			</Tooltip>
		);
	}
}
